import Vue from 'vue'
import Vuex from 'vuex'

const store = new Vuex.Store({
  state: {
    translations: {

    }
  },
  mutations: {
    setTranslation: (state, {key, value}) => {
      Vue.set(state.translations, key, value)
    }
  },
  actions: {
    setTranslation: ({ commit }, {key, value}) => {
      commit('setTranslation', {key, value})
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./app/javascript/state/store.js